/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Term_TitleInputs */

const en_mk_term_title = /** @type {(inputs: Mk_Term_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`terminal — my-app`)
};

const id_mk_term_title = /** @type {(inputs: Mk_Term_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`terminal — my-app`)
};

/**
* | output |
* | --- |
* | "terminal — my-app" |
*
* @param {Mk_Term_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_term_title = /** @type {((inputs?: Mk_Term_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Term_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_term_title(inputs)
	return en_mk_term_title(inputs)
});